import { render, staticRenderFns } from "./UnconfirmedDefectMark.vue?vue&type=template&id=602ca798&scoped=true"
import script from "./UnconfirmedDefectMark.vue?vue&type=script&lang=js"
export * from "./UnconfirmedDefectMark.vue?vue&type=script&lang=js"
import style0 from "./UnconfirmedDefectMark.vue?vue&type=style&index=0&id=602ca798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602ca798",
  null
  
)

export default component.exports